import React from 'react'
import { Box, Stack, Typography, IconButton } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'

interface ModalHeaderProps {
  icon?: React.ReactNode
  subtitle: string
  title: string
  onClose: () => void
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  icon = <AddIcon sx={{ fontSize: 16, color: '#2570EB' }} />,
  subtitle,
  title,
  onClose
}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 3 }}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: '#DBE8FE',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {icon}
        </Box>
        <Stack spacing={0.2}>
          <Typography
            variant="body2"
            sx={{
              fontSize: '11px',
              color: '#666',
              textTransform: 'capitalize',
              lineHeight: 1.2
            }}
          >
            {subtitle}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: '14px',
              fontWeight: 600,
              color: '#000',
              lineHeight: 1.2,
              textTransform: 'none'
            }}
          >
            {title}
          </Typography>
        </Stack>
      </Stack>
      <IconButton onClick={onClose} size="small">
        <CloseIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Stack>
  )
}

export default ModalHeader